import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
// import * as XLSX from 'xlsx';

@Component({
  selector: 'app-send-reminder-letter-issue-rep',
  templateUrl: './send-reminder-letter-issue-rep.component.html',
  styleUrl: './send-reminder-letter-issue-rep.component.scss'
})
export class SendReminderLetterIssueRepComponent {

  currentDate: Date;
  getpendingreceipt: any;
  PendingReceiptAmt: number;
  PendingBalanceAmt: number;
  isEditMode: boolean = false;
  isSaving: boolean = false;

  // WhatsApp sending state
  sendingWhatsAppReminder: boolean = false;
  isWhatsAppSent: boolean = false;

  // Add these new properties for address and advt_name
  advtName: string = '';
  advtAddress: string = '';

  // Dynamic letter body text
  letterBodyText = {
    template_name: 'send-reminder2',
    subject_line: '',
    greeting: '',
    paragraph1: '',
    paragraph2: '',
    paragraph3: '',
    details_heading: '',
    closing_text: ''
  };

  // Default text (fallback if API fails or no data)
  defaultLetterText = {
    template_name: 'send-reminder2',
    subject_line: 'विषय : मागील जाहिरात येणे बाकी सदंर्भात स्मरण पत्र .........',
    greeting: 'सस्नेह नमस्कार',
    paragraph1: 'साप्ताहिक विवेक हे महाराष्ट्रातील सर्व घडामोडींचा आढावा घेणारे वैचारिक साप्ताहिक आहे. सा. विवेकचा मागील 78 वर्षाचा प्रवास आपल्या सारख  प्रतिनिधींच्या/हितचिंतकांच्या माध्मातून होणार्‍या अर्थपूर्ण सहकार्यावर यशस्वीपणे होत आलेला आहे. आजच्या आधुनिक व व्यवहारी काळात अखंडपणे प्रवास चालू ठेवणे फार जिकरीचे असते. हे आपणास माहित आहेच.',
    paragraph2: 'साप्ताहिक विवेकद्वारा प्रकाशित अंक/विशेषांकाकरीता आपण जाहिराती पाठविल्या होत्या. या अंकाच्या  यशस्वीतेकरिता आपल्याकडून लाभलेल्या मौलिक योगदानाची जाणीव आम्हाला आहे.',
    paragraph3: `या पत्रासोबत येणे बाकी जाहिरातदारांची यादी आपल्या माहितीकरिता पाठवत आहे.
              कृपया सदर येणे बाकी लवकरात लवकर जमा होण्यासाठी प्रयत्न करावित, ही विनंती.
          सा. विवेक व आपले आपुलकीचे संबंध आहेत. या पुढेही दृढ व्हावेत, ही सदिच्छा!`,
    details_heading: 'येणे बाकी तपशील खालील प्रमाणे आहे.',
    closing_text: 'ही पत्रेरी आपल्याला हवी असलेली बक्षीस रक्कम संपूर्ण करण्यासाठी आपल्याला नम्र विनंती करत आहे.'
  };


  constructor(
    private dialogRef: MatDialogRef<SendReminderLetterIssueRepComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) { }

  reportType: any;
  startDate: any;
  endDate: any;
  repName: any;
  offRepName: any;
  issueDates: any;
  issueDates1: any;
  getpendingreceiptrep: any;
  selectedRepName: any;
  selectedRepAddress: any;
  selectedRepMobileNo: any; // 👈 mobile number used for WhatsApp

  OutStandingIDTotal: number = 0;
  OutStandingIDNetAmtTotal: number = 0;
  OutStandingIDUnPaidTotal: number = 0;

  ngOnInit(): void {

    this.currentDate = new Date();

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'] || this.data['advt_name'] || '';
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];

    // Load letter template from backend
    this.loadLetterTemplate();

    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.advtName,
      "issue_name": "",
      "issue_date": this.issueDates1
    }
    this.service.getpendingreceiptRepissue(req).subscribe((data: any) => {

      // ✅ Drop blank/placeholder rows the API returns (rows with no invoice_no)
      // so the printed table doesn't show empty lines after the real data.
      this.getpendingreceiptrep = (data || []).filter((row: any) => !!row.invoice_no);

      console.log("pending receipt", this.getpendingreceiptrep);

      // ===== store rep_name, address & mobile no =====
      if (this.getpendingreceiptrep.length > 0) {
        this.selectedRepName = this.getpendingreceiptrep[0].rep_name;        // 👈 Save rep name
        this.selectedRepAddress = this.getpendingreceiptrep[0].address;      // 👈 Save address
        this.selectedRepMobileNo = this.getpendingreceiptrep[0].rep_mobile_no
          || this.getpendingreceiptrep[0].mobile_no
          || '';                                                             // 👈 Save mobile no (adjust field name to match your API)
      }

      // Reset totals
      this.PendingReceiptAmt = 0;
      this.PendingBalanceAmt = 0;

      // Calculate totals
      for (let row of this.getpendingreceiptrep) {
        this.PendingReceiptAmt += Number(row.advt_amt) || 0;
        this.PendingBalanceAmt += Number(row.remain_amt) || 0;
      }

      this.cdr.detectChanges();
    });

  }

  /**
   * Load letter template from backend
   */
  loadLetterTemplate(): void {
    this.service.getLetterTemplaterepissueseller('send-reminder2').subscribe(
      (response: any) => {
        console.log('Letter template response:', response);

        if (response && response.success && response.data) {
          const data = response.data;

          this.letterBodyText = {
            template_name: data.template_name || 'send-reminder2',
            subject_line: data.subject_line || this.defaultLetterText.subject_line,
            greeting: data.greeting || this.defaultLetterText.greeting,
            paragraph1: data.paragraph1 || this.defaultLetterText.paragraph1,
            paragraph2: data.paragraph2 || this.defaultLetterText.paragraph2,
            paragraph3: data.paragraph3 || this.defaultLetterText.paragraph3,
            details_heading: data.details_heading || this.defaultLetterText.details_heading,
            closing_text: data.closing_text || this.defaultLetterText.closing_text
          };
        } else {
          console.log('No template found, using default');
          this.letterBodyText = { ...this.defaultLetterText };
        }
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error loading letter template:', error);
        this.letterBodyText = { ...this.defaultLetterText };
        this.cdr.detectChanges();
      }
    );
  }

  /**
   * Toggle edit mode on/off
   */
  toggleEditMode(): void {
    this.isEditMode = !this.isEditMode;

    if (!this.isEditMode) {
      this.loadLetterTemplate();
    }
  }

  /**
   * Save letter template to backend
   */
  saveLetterTemplaterep(): void {
    if (!this.letterBodyText.template_name) {
      alert('टेम्पलेट नाव आवश्यक आहे!');
      return;
    }

    this.isSaving = true;

    this.service.saveLetterIssueSellerTemplaterep(this.letterBodyText).subscribe(
      (response: any) => {
        console.log('Letter template saved successfully', response);
        this.isSaving = false;

        if (response && response.success) {
          alert('पत्र टेम्पलेट यशस्वीरित्या जतन केले! (Template saved successfully!)');
          this.isEditMode = false;
          this.cdr.detectChanges();
        } else {
          alert('त्रुटी: ' + (response.message || 'टेम्पलेट जतन करताना त्रुटी'));
        }
      },
      (error) => {
        console.error('Error saving letter template:', error);
        this.isSaving = false;
        alert('पत्र टेम्पलेट जतन करतानाची त्रुटी! (Error saving template!)');
      }
    );
  }

  /**
   * Reset to default template
   */
  resetToDefault(): void {
    if (confirm('तुम्हाला खरोखर डिफॉल्ट टेम्पलेट रीसेट करायचे आहे का? (Do you want to reset to default template?)')) {
      this.letterBodyText = { ...this.defaultLetterText };
      this.saveLetterTemplaterep();
    }
  }

  /**
   * Update specific field
   */
  updateLetterField(field: string, value: string): void {
    if (this.letterBodyText.hasOwnProperty(field)) {
      this.letterBodyText[field] = value;
    }
  }

  formatDate(date: Date): string {
    const d = ('0' + date.getDate()).slice(-2);
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }

  /**
   * Send WhatsApp reminder for this rep/advertiser using the "yeneissue" campaign.
   * Message template (3 params -> {{1}} name, {{2}} date, {{3}} amount):
   *
   * प्रति,
   * {{1}}
   * दिनांक {{2}} अखेर आपल्या खात्यावर रु. {{3}} /- येणे बाकी आहे.
   * आपणास नम्र विनंती आहे की, सदर दयेयक रक्कम लवकरात लवकर जमा करावी.
   * रक्कम जमा केल्यानंतर त्याचा तपशील (Payment Details) आम्हाला त्वरित कळवावा, धन्यवाद.
   * सा.विवेक - वर्गणी व विक्री विभाग.
   */
  sendWhatsAppReminder(): void {

    if (!this.getpendingreceiptrep?.length) {
      alert('पाठवण्यासाठी कोणताही डेटा उपलब्ध नाही.');
      return;
    }

    if (!this.selectedRepMobileNo) {
      alert('मोबाईल नंबर उपलब्ध नाही. (Mobile number not found)');
      return;
    }

    const payload = {
      mobile: String(this.selectedRepMobileNo),
      campaignName: 'yeneissue',
      templateParams: [
        this.selectedRepName || this.repName || '',
        this.formatDate(this.currentDate),
        Number(this.PendingBalanceAmt).toFixed(2)
      ]
    };

    this.sendingWhatsAppReminder = true;

    this.service.sendWhatsAppReceipt(payload).subscribe({
      next: () => {
        this.sendingWhatsAppReminder = false;
        this.isWhatsAppSent = true;
        alert('WhatsApp यशस्वीरित्या पाठवले!');
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.sendingWhatsAppReminder = false;
        console.error('WhatsApp failed:', err);
        alert('WhatsApp पाठवताना त्रुटी आली!');
      }
    });
  }

  // In your component.ts file


  show = false

  printPage() {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
             @page {
  size: A4 portrait;
  margin: 5mm;
}
              .reminder-container {
    max-width: 210mm;
    margin: 0 auto;
    padding: 20px;
    border: 2px solid #000;
    background: #fff;
    font-family: 'Noto Sans Devanagari', Arial, sans-serif;
    color: #000 !important;
}

/* Header Section */
.header-section {
    padding-bottom: 15px;
    color: #000 !important;
}

.header-content {
    color: #000 !important;
}

.header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
}

.organization-info {
    flex: 1;
    text-align: right;
    line-height: 1.6;
    margin-right: 55px;
}

.organization-name {
    font-size: 20px;
    font-weight: bold;
    margin: 0 0 5px 0;
    color: #000;
    text-align: right;
    margin-right: 3px;
}

.registration-number {
    font-size: 13px;
    color: #000 !important;
    margin-right: 55px;
    text-align: right;
    margin: 0 0 5px 0;
}

.header-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    margin-left: 20px;
}

.header-logo img {
    margin-right: 50px;
    max-width: 190px;
    margin-top: 12px;
}

.header-divider {
    margin: 10px 0;
    border: none;
    border-top: 1px solid #333;
}

.office-details-single {
    font-size: 13px;
    line-height: 1.6;
    color: #000 !important;
    text-align: left;
}

.office-label {
    font-weight: bold;
    color: #000 !important;
}

.contact-label {
    font-weight: bold;
    color: #000 !important;
    margin-left: 188px;
}

/* Recipient Section */
.recipient-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 20px 0;
}

.recipient-address {
    text-align: left;
}

.date-section {
    padding-left: 20px;
    text-align: right;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    color: #000 !important;
}

.field-label {
    font-weight: bold;
    font-size: 15px;
}

.field-row {
    margin: 8px 0;
    font-size: 14px;
}

.field-value {
    font-size: 14px;
}

/* Content Section */
.content-section {
    padding: 20px 0;
    text-align: left;
}

.subject-line {
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
    color: #000 !important;
}

.greeting {
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
}

.letter-body {
    font-size: 14px;
    line-height: 1.8;
    text-align: justify;
    color: #000 !important;
}

.letter-body p {
    margin: 12px 0;
    text-indent: 40px;
    color: #000 !important;
}

.details-heading {
    font-weight: bold;
    margin-top: 20px !important;
    color: #000 !important;
}

/* Table Section */
.table-wrapper {
    margin: 20px 0;
    overflow-x: auto;
    color: #000 !important;
}

.details-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    color: #000 !important;
}

.details-table th,
.details-table td {
    border: 1px solid #333;
    padding: 10px;
    text-align: center;
    color: #000 !important;
}

.details-table th {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 14px;
    color: #000 !important;
}

.details-table tbody tr:hover {
    background-color: #f9f9f9;
    color: #000 !important;
}

.total-row {
    font-weight: bold;
    background-color: #f5f5f5;
    color: #000 !important;
}

.closing-text {
    margin: 20px 0;
    font-size: 14px;
    text-indent: 40px;
}

.signature-section {
    text-align: right;
    margin: 40px 0 60px 0;
    font-size: 14px;
}

.signature-section p {
    margin: 5px 0;
}

/* Footer Section */
.footer-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding-top: 15px;
    border-top: 2px solid #000;
}

.footer-note {
    font-weight: bold;
    font-size: 15px;
    text-align: left;
}
  
.footer-signature { 
    font-weight: bold;
    font-size: 15px;
    text-align: right;
}
          </style>
        </head>
        <body>
          <div id="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}